import React from 'react';
import SummaryInfoStatus from './SummaryInfoStatus';
import SummaryInfoList from './SummaryInfoList';
import { RecordDataType } from './SummaryRecordModal';
import { ResumeChecklistProjectType } from './ResumeChecklistCellRenderer';
import { IcoReported } from '@icons';
import { dateFormatter } from '@lib/helpers/formatting';

interface SummaryRecordModalInfoProps {
	recordData: RecordDataType;
	project: ResumeChecklistProjectType;
}

const SummaryRecordModalInfo: React.FC<SummaryRecordModalInfoProps> = ({ recordData, project }) => {
	const items = [
		{
			label: 'CUP',
			value: recordData?.project?.cup,
		},
		{
			label: 'Sottovoce di spesa',
			value: recordData?.projectExpenseItem?.name,
		},
		{
			label: 'Nr. Record',
			value: recordData?.number,
		},
		{
			label: 'Matricola',
			value: recordData?.serialNumber,
		},
		...(!project.sco
			? [
					{
						label: 'Cognome',
						value: recordData?.employee?.surname,
					},
					{
						label: 'Nome',
						value: recordData?.employee?.name,
					},
				]
			: []),
		{
			label: 'Unità Operativa',
			value: recordData?.operationalUnit,
		},
		{
			label: 'Società',
			value: recordData?.company,
		},
		{
			label: 'Data Ingresso',
			value: dateFormatter(recordData?.entryDate, 'DD/MM/YYYY'),
		},
		{
			label: 'Data Uscita',
			value: dateFormatter(recordData?.exitDate, 'DD/MM/YYYY'),
		},
		{
			label: 'Categoria',
			value: recordData?.category,
		},
		{
			label: 'Malattia',
			value: recordData?.sickDays,
		},
		{
			label: 'Ferie',
			value: recordData?.vacationDays,
		},
		{
			label: 'Permessi',
			value: recordData?.leaveDays,
		},
		{
			label: 'Fattispecie RSI',
			value: recordData?.rdiTypeCode,
		},
		{
			label: 'Avvio progetto',
			value: dateFormatter(recordData?.project?.startDate, 'DD/MM/YYYY'),
		},
	];

	const detailFields = [
		{
			label: 'Rendicontato',
			key: 'reported',
		},
		{
			label: 'Anno',
			key: 'year',
		},
		{
			label: 'Mese',
			key: 'month',
		},
		{
			label: 'Giorno',
			key: 'day',
		},
		{
			label: 'Ore Totali',
			key: 'workHours',
		},
		{
			label: 'Ore Sul Progetto',
			key: 'projectHours',
		},
		{
			label: 'Costo Orario €',
			key: 'hourlyRate',
		},
		{
			label: 'Costo Sul Progetto €',
			key: 'projectCost',
		},
		{
			label: 'Resp. Budget',
			key: 'budgetResponsability',
		},
		{
			label: project.streamConfigurationType === 'STREAM ' ? 'Stream' : 'WP',
			key: 'streamName',
		},
		{
			label: 'WBE',
			key: 'wbe',
		},
		{
			label: 'CID',
			key: 'cid',
		},
	];

	const detailsWithNames = recordData.details.map((detail) => {
		return {
			...detail,
			streamName: `${detail.stream?.streamId} - ${detail.stream?.name} `,
		};
	});

	return (
		<div className="summary_info-container">
			<SummaryInfoStatus entityLabel="Stato del timesheet" checklistColor={recordData.checkliststatus?.color} />

			<div>
				<h4>Dati timesheet</h4>

				<SummaryInfoList items={items} />
				<hr />
				<div>
					<h4>Dettaglio</h4>
					{detailsWithNames.map((detail) => {
						if (detail.workHours === 0) {
							return null;
						}
						return (
							<div
								key={detail.id}
								style={{
									display: 'grid',
									gridTemplateColumns: 'auto 1fr',
									marginBottom: '3rem',
								}}
							>
								<div
									style={{
										fontWeight: 700,
										backgroundColor: '#EDF0F7',
										padding: '1rem',
										borderTopLeftRadius: '8px',
										borderBottomLeftRadius: '8px',
									}}
								>
									Posizione
									<br />
									{detail.id}
								</div>
								<div
									style={{
										padding: '1rem',
										display: 'grid',
										gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
										gap: '1rem',
									}}
								>
									{detailFields.map((field) => {
										if (field.key === 'reported' && !detail[field.key]) {
											return null;
										}

										return (
											<div
												key={field.key}
												style={{
													padding: '0.5rem',
													fontSize: '14px',
												}}
											>
												<div
													style={{
														fontWeight: 700,
													}}
												>
													{field.label}
												</div>

												<div>
													{detail[field.key] ?? 'N.D.'}
													{field.key === 'reported' ? <IcoReported /> : null}
												</div>
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default SummaryRecordModalInfo;
